import React, { Component } from 'react'
import StagesManager from '../StagesManager'
import ActionButton from './ActionButton'
import ActionsList from './ActionsList'
import SendTo from './SendTo'
import TasksList from './TasksList'
import ChangeStage from './ChangeStage'
import TempMessage from './TempMessage'

export default class ActionsBtn extends Component {

    actionClicked = (prop, data, index, extra) => {

        // console.log('itemitemitemitem',prop, data, index, extra)
        // console.log('prop, data, index)ss',prop, data, index)

        let stageList = ['sendTo', 'changeStage', 'templateMessage']
        // console.log('fairstprop',prop)
        if (stageList.includes(prop.key)) {
            let cIndex = stageList.indexOf(prop.key)
            if (prop.key == 'changeStage') {
                this.props.actionClicked(prop, data, index, extra)
            }
            this.stageManager.changeStage(stageList[cIndex])
        }
        else {
            // console.log("prop",prop)
            this.props.actionClicked(prop, data, index, extra)
            this.actionsButton.hide()

        }
    }

    lastPage = () => {
        this.stageManager.lastStage()
    }

    actionIsOpen = (prop) => {
    }

    onActionOpen = () => {

        this.setState({ actionIsOpen: true })
        if (this.props.onOpen) {
            this.props.onOpen()
        }
    }

    onActionClose = () => {

        this.setState({ actionIsOpen: false })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }




    render() {


        return (
            // <div className='w-100'>
            <ActionButton ref={el => this.actionsButton = el} showText={this.props.showText} onOpen={() => this.onActionOpen()} onClose={() => { this.onActionClose() }} colors={this.props.colors}>
                <div className=" px-1 py-1  d-flex flex-column w-100 " style={{ minWidth: 190, boxShadow: '0px 0px 30px #10101030', backgroundColor: '#fff', borderRadius: 10 }}>
                    <div className='sc-gray2 w-100' style={{ maxHeight: 250, overflow: 'auto', }}>

                        {/* <div className='br-4 px-2 py-2 mb-1 ' style={{border:'1px solid rgb(0, 205, 116)',color:'rgb(0, 205, 116)',backgroundColor:'rgba(0, 205, 116,0.05)'}}>
                                        <p className='text-smaller'>Mark as Done</p>
                                    </div> */}
                        {/* {console.log(this.props.actions)} */}
                        <StagesManager ref={e => this.stageManager = e} width={100} fast={true}>
                            <ActionsList stage={0} stageName='actions' permissions={this.props.permissions} page={this.props.page} functionsHandler={this.props.functionsHandler} applet={this.props.applet} actionClicked={this.actionClicked} actions={this.props.actions} data={this.props.data} index={this.props.index} language={this.props.language} colors={this.props.colors} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} />
                            <SendTo stage={1} stageName='sendTo' applet={this.props.applet} lastPage={this.lastPage} actionClicked={this.actionClicked} functionsHandler={this.props.functionsHandler} actions={this.props.actions} data={this.props.data} index={this.props.index} language={this.props.language} colors={this.props.colors} />
                            <TempMessage stage={1} stageName='templateMessage' page={this.props.page} applet={this.props.applet} lastPage={this.lastPage} functionsHandler={this.props.functionsHandler} actionClicked={this.actionClicked} actions={this.props.actions} data={this.props.data} index={this.props.index} language={this.props.language} colors={this.props.colors} />
                            <ChangeStage stage={1} stageName='changeStage' applet={this.props.applet} lastPage={this.lastPage} actionClicked={this.actionClicked} functionsHandler={this.props.functionsHandler} actions={this.props.actions} data={this.props.data} index={this.props.index} language={this.props.language} currentRecord={this.props.currentRecord} currentRecordStage={this.props.currentRecordStage} changeRecordStage={this.props.changeRecordStage} setCurrentRecordStage={this.props.setCurrentRecordStage} colors={this.props.colors} />
                            {/* <TasksList stage={1} stageName='subTask' data={this.props.data} index={this.props.index} /> */}
                        </StagesManager>



                        {/* <p className='mt-1 mb-1 px-2 text-smaller text-semibold color-gray-2'>{translate("Dynamic Actions")}</p>


                                    {this.props.actions && Object.values(this.props.actions).map((prop, index) => {
                                        return (

                                            <IntractionActionsList language={this.props.language} data={{ title: prop.label, sub: prop.sub, shortcut: null, icon: "/assets/icons/note/file/open.svg" }} />

                                        )
                                    })} */}
                    </div>

                </div>
            </ActionButton>
            // </div>
        )
    }
}
